import { toast } from 'react-toastify';
import React, { useState, useEffect, useCallback } from "react";
import { Upload } from 'antd';
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { Box, IconButton, alpha } from "@mui/material";
import "./index.scss";
import api from "../../../hooks/api";
import { pathAPI } from "../../../utils/pathApi";
import { fileToBlob } from "../../../utils/utils";
import { message } from "antd";

interface UploadImageProp {
  width?: string | number;
  height?: string | number;
  urlImage?: string;
  onChangeFile?: (file: File | null) => void;
}

const UploadImage: React.FC<UploadImageProp> = ({
  height,
  width,
  urlImage,
  onChangeFile,
}) => {
  const [previewImage, setPreviewImage] = useState<string>(urlImage || "");
  const [file, setFile] = useState<File | null>(null);
  const { Dragger } = Upload;

  const postImage = async (data: any) => {
    await api
      .POST(pathAPI.uploadImage.replace(":type", "IMAGE"), data, {}, true)
      .then((data: any) => {
        console.log("data", data);
      })
      .catch((e: any) => console.log("error", e));
  };

  useEffect(() => {
    onChangeFile && onChangeFile(file);
  }, [file]);

  const handlePreview = async (file: any) => {
    setFile(file);
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file);
    }
    setPreviewImage(file.url || file.preview);
  };

  const getBase64 = (file: File) => {
    return new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
    });
  };

  const handlePaste = useCallback((event: ClipboardEvent) => {
    const items = event.clipboardData?.items;
    if (!items) return;

    Array.from(items).forEach(item => {
      if (item.type.indexOf('image') !== -1) {
        const file = item.getAsFile();
        if (file) {
          handlePreview(file);
        }
      }
    });
  }, []);

  useEffect(() => {
    document.addEventListener('paste', handlePaste);
    return () => {
      document.removeEventListener('paste', handlePaste);
    };
  }, [handlePaste]);

  return (
    <Box
      position={"relative"}
      height={height || 120}
      width={width || 120}
      overflow={"hidden"}
      sx={{borderRadius: '10px'}}
    >
      {previewImage ? (
        <Box
          height={height || 120}
          width={width || 120}
          className="img-preview"
          textAlign={"center"}
          sx={{borderRadius: '10px'}}
        >
          <Box
            component={"img"}
            height={"100%"}
            width={"100%"}
            alt="Preview"
            src={previewImage}
            style={{ borderRadius: "10px" }}
          />

          <Box
            position={"absolute"}
            height={height || 120}
            width={width || 120}
            top={0}
            left={0}
            bgcolor={alpha("#000", 0.5)}
            display={"flex"}
            alignItems={"center"}
            zIndex={10}
            className="img-delete"
            justifyContent={"center"}
          >
            <IconButton
              component="span"
              sx={{ color: "#fff", fontSize: 20 }}
              onClick={() => {
                setPreviewImage("");
                setFile(null);
              }}
            >
              <DeleteOutlined />
            </IconButton>
          </Box>
        </Box>
      ) : (
        <Dragger
          style={{ width: width || 120, height: height || 120 }}
          showUploadList={false}
          beforeUpload={(file) => {
            const isImage = file.type.startsWith('image/');
            if (!isImage) {
              toast.error('You can only upload image files!');
              return false;
            }
            return false;
          }}
          onPreview={handlePreview}
          onChange={(e) => handlePreview(e.file)}
          accept="image/*"
        >
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            height: '100%',
            gap: 1
          }}>
            <UploadOutlined style={{ fontSize: '20px', color: 'var(--app-text-muted)' }} />
            <div style={{ fontSize: '12px', color: 'var(--app-text-muted)' }}>Click to upload</div>
          </Box>
        </Dragger>
      )}
    </Box>
  );
};

export default UploadImage;
